import { forwardRef } from 'react';
import cn from 'classnames';

import { type DiceGameCardProps } from '@/common/types/dice-game';
import { Picture } from '@/components/ui/Picture/Picture';

import { ActiveBorder } from '../ActiveBorder/ActiveBorder';

import css from './styles.module.scss';

import yellowBgPng from '/img/dice-game/yellow-card-bg.png';
import yellowBgWebp from '/img/dice-game/yellow-card-bg.webp';

const ZeroCard = forwardRef<HTMLDivElement, DiceGameCardProps>(
  ({ isActive, ...props }, ref) => {
    return (
      <div ref={ref} {...props} className={cn(css.zeroCard, props.className)}>
        <div className="absolute overflow-hidden rounded-xl top-0 left-0 w-full h-full">
          <Picture
            className="w-full h-full"
            img={yellowBgPng}
            webp={yellowBgWebp}
            alt="light"
          />
        </div>
        <span
          className={cn(
            'font-black text-[6.04vh] text-[#FFEB7E] !leading-none relative z-[1] -translate-y-[2px]',
            css.textShadow,
          )}
        >
          0
        </span>
        {isActive && <ActiveBorder variant="yellow" />}
      </div>
    );
  },
);

export { ZeroCard };
